@if (indicatorBars) {
    @for (indicatorBar of indicatorBars; track indicatorBar) {
        <div
            class="indicator-bar"
            [ngClass]="{'indicator-bar--active': activeBar === indicatorBar + 1}"
            (click)="handleIndicatorClick(indicatorBar)"
        ></div>
    }
}
